export default __webpack_public_path__ + "static/media/Imagenine.c62472c0.jpeg";